// extracted by mini-css-extract-plugin
export default {"wrapper":"xB-z","viewport":"yB-z","container":"zB-z","slide":"AB-z"};